import { Controller } from "@hotwired/stimulus"

export default class FlashElementController extends Controller {
  static classes = ["highlight"]
  static values = {
    duration: { type: Number, default: 3000 },
  }

  flash({ detail: { id } }) {
    const element = this.element.querySelector(
      `[data-flash-element-identifier="${id}"]`
    )

    this.#clear()

    element.classList.add(...this.highlightClasses)
    this.flashed = element
    this.timeout = setTimeout(() => this.#clear(), this.durationValue)
  }

  disconnect() {
    this.#clear()
  }

  #clear() {
    clearTimeout(this.timeout)
    this.timeout = null

    if (!this.flashed) return

    this.flashed.classList.remove(...this.highlightClasses)
    this.flashed = null
  }
}
